import { IEventFlightTravelLegParams } from "Bands/types";
import { merge } from "lodash-es";
import { API_ENDPOINTS } from "shared/constants";

export const useOnSubmitTravelLeg = (
  handleSubmit: (data: IEventFlightTravelLegParams) => void,
  start?: string,
  end?: string
) => {
  const onSubmit = (data: IEventFlightTravelLegParams) => {
    const cleanData: IEventFlightTravelLegParams = merge({}, data, {
      departure: {
        location: API_ENDPOINTS.EVENT_SUGGESTED_LOCATION(
          data.departure?.location || ""
        ),
        time: start,
      },
      arrival: {
        location: API_ENDPOINTS.EVENT_SUGGESTED_LOCATION(
          data.arrival?.location || ""
        ),
        time: end,
      },
    });

    handleSubmit(cleanData);
  };

  return { onSubmit };
};
